// notificationActions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CreateNotificationPayload,
  NotificationByIdPayload,
  DeactivateNotificationPayload
} from './notificationTypes';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Notification
export const createNotification = createAsyncThunk(
  'notifications/createNotification',
  async (data: CreateNotificationPayload, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/notifications', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create notification');
    }
  }
);

// Fetch All Notifications
export const fetchAllNotifications = createAsyncThunk(
  'notifications/fetchAllNotifications',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/notifications');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch notifications');
    }
  }
);

// Fetch Notification by ID
export const fetchNotificationById = createAsyncThunk(
  'notifications/fetchNotificationById',
  async ({ id }: NotificationByIdPayload, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/notifications/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch notification');
    }
  }
);

// Deactivate Notification
export const deactivateNotification = createAsyncThunk(
  'notifications/deactivateNotification',
  async ({ id }: DeactivateNotificationPayload, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.patch(`/notifications/${id}`);
      return { ...response.data, id };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to deactivate notification');
    }
  }
);
